<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <h2>{{ $t('满赠活动') }}</h2>
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24"><a-form-item :label="$t('活动名称')"><a-input v-model="queryParam.name" :placeholder="$t('请输入活动名称')" allow-clear @pressEnter="handleQuery" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item :label="$t('活动时间')"><a-range-picker v-model="activityTime" show-time value-format="YYYY-MM-DD HH:mm:ss" style="width:100%" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item :label="$t('创建人')"><a-input v-model="queryParam.creator" :placeholder="$t('请输入创建人账号或昵称')" allow-clear @pressEnter="handleQuery" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item :label="$t('活动状态')"><a-select v-model="queryParam.status" :placeholder="$t('请选择活动状态')" allow-clear style="width:100%"><a-select-option :value="0">{{ $t('已下架') }}</a-select-option><a-select-option :value="1">{{ $t('未开始') }}</a-select-option><a-select-option :value="2">{{ $t('进行中') }}</a-select-option><a-select-option :value="3">{{ $t('已结束') }}</a-select-option></a-select></a-form-item></a-col>
            <a-col :span="24" style="text-align:right"><a-button type="primary" @click="handleQuery"><a-icon type="search" /> {{ $t('查询') }}</a-button><a-button style="margin-left:8px" @click="resetQuery"><a-icon type="redo" /> {{ $t('重置') }}</a-button></a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations"><a-button type="primary" v-hasPermi="['activity:fullgift:add']" @click="$refs.createForm.handleAdd()"><a-icon type="plus" /> {{ $t('新增') }}</a-button></div>
      <a-table
        row-key="id"
        :loading="loading"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :scroll="{x: 1300}"
      >
        <template slot="activityTime" slot-scope="text, row">{{ parseTime(row.startTime) }}<br />{{ $t('至') }} {{ parseTime(row.endTime) }}</template>
        <template slot="scopeType" slot-scope="text">{{ scopeNames[text] }}</template>
        <template slot="thresholdType" slot-scope="text">{{ text === 1 ? $t('原价') : $t('实付') }}</template>
        <template slot="tierSummary" slot-scope="text, row"><a @click="showTierSummary(row)">{{ $t('查看阶梯') }}</a></template>
        <template slot="status" slot-scope="text, row"><a-tag :color="statusColors[row.activityStatus]">{{ statusNames[row.activityStatus] }}</a-tag></template>
        <template slot="operation" slot-scope="text, row">
          <a v-if="row.activityStatus !== 2" v-hasPermi="['activity:fullgift:edit']" @click="$refs.createForm.handleUpdate(row)"><a-icon type="edit" /> {{ $t('编辑') }}</a>
          <a v-else v-hasPermi="['activity:fullgift:query']" @click="$refs.createForm.handleUpdate(row)"><a-icon type="eye" /> {{ $t('查看') }}</a>
          <a-divider type="vertical" />
          <a v-hasPermi="['activity:fullgift:status']" @click="toggleStatus(row)">{{ row.status === 1 ? $t('下架') : $t('上架') }}</a>
          <template v-if="row.status === 1"><a-divider type="vertical" /><a v-hasPermi="['activity:fullgiftstock:query']" @click="$refs.stockForm.show(row)">{{ $t('增加库存') }}</a></template>
          <template v-if="row.status !== 1"><a-divider type="vertical" /><a v-hasPermi="['activity:fullgift:remove']" class="danger-link" @click="remove(row)">{{ $t('删除') }}</a></template>
        </template>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :total="total"
        :show-total="value => `${$t('共')}${value}${$t('条')}`"
        @change="changePage"
        @showSizeChange="changePage"
      />
    </a-card>
    <create-form ref="createForm" @ok="getList" />
    <increase-stock-form ref="stockForm" @ok="getList" />
  </page-header-wrapper>
</template>

<script>
import { changeFullGiftStatus, deleteFullGift, getFullGift, pageFullGift } from '@/api/activity/fullGift'
import CreateForm from './modules/CreateForm'
import IncreaseStockForm from './modules/IncreaseStockForm'

export default {
  name: 'FullGift',
  components: { CreateForm, IncreaseStockForm },
  data () {
    return {
      loading: false,
      list: [],
      total: 0,
      activityTime: [],
      scopeNames: { 1: this.$t('全部商品'), 2: this.$t('指定商品'), 3: this.$t('指定分类') },
      statusNames: { 0: this.$t('已下架'), 1: this.$t('未开始'), 2: this.$t('进行中'), 3: this.$t('已结束') },
      statusColors: { 0: 'default', 1: 'blue', 2: 'green', 3: 'orange' },
      queryParam: { name: undefined, creator: undefined, status: undefined, startTime: undefined, endTime: undefined, pageNum: 1, pageSize: 10 },
      columns: [
        { title: this.$t('活动名称'), dataIndex: 'name', width: 180 },
        { title: this.$t('活动时间'), width: 220, scopedSlots: { customRender: 'activityTime' } },
        { title: this.$t('范围'), dataIndex: 'scopeType', width: 100, scopedSlots: { customRender: 'scopeType' } },
        { title: this.$t('门槛口径'), dataIndex: 'thresholdType', width: 100, scopedSlots: { customRender: 'thresholdType' } },
        { title: this.$t('优先级'), dataIndex: 'priority', width: 80 },
        { title: this.$t('阶梯概要'), width: 100, scopedSlots: { customRender: 'tierSummary' } },
        { title: this.$t('创建人'), dataIndex: 'creatorName', width: 120 },
        { title: this.$t('状态'), dataIndex: 'status', width: 90, scopedSlots: { customRender: 'status' } },
        { title: this.$t('操作'), width: 280, fixed: 'right', scopedSlots: { customRender: 'operation' } }
      ]
    }
  },
  created () { this.getList() },
  methods: {
    getList () {
      this.loading = true
      pageFullGift(this.queryParam).then(response => {
        this.list = response.data.records || []
        this.total = Number(response.data.total || 0)
      }).finally(() => { this.loading = false })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.queryParam.startTime = this.activityTime && this.activityTime[0]
      this.queryParam.endTime = this.activityTime && this.activityTime[1]
      this.getList()
    },
    resetQuery () {
      this.queryParam = { name: undefined, creator: undefined, status: undefined, startTime: undefined, endTime: undefined, pageNum: 1, pageSize: 10 }
      this.activityTime = []
      this.getList()
    },
    changePage (pageNum, pageSize) {
      this.queryParam.pageNum = pageNum
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    toggleStatus (row) {
      const next = row.status === 1 ? 0 : 1
      this.$confirm({ title: `${this.$t(next === 1 ? '确认上架活动' : '确认下架活动')} “${row.name}”?`, onOk: () => changeFullGiftStatus({ id: row.id, status: next }).then(() => { this.$message.success(this.$t('状态更新成功')); this.getList() }) })
    },
    remove (row) {
      this.$confirm({ title: `${this.$t('确认删除活动')} “${row.name}”?`, onOk: () => deleteFullGift({ id: row.id }).then(() => { this.$message.success(this.$t('删除成功')); this.getList() }) })
    },
    async showTierSummary (row) {
      const response = await getFullGift({ id: row.id })
      const text = (response.data.tiers || []).map(item => `${this.$t('满')} ${item.thresholdAmount}, ${this.$t('赠品')} ${item.skus.length} ${this.$t('种')}, ${this.$t('剩余')} ${item.remainingStock}`).join('; ')
      this.$info({ title: `${row.name} - ${this.$t('阶梯概要')}`, content: text || this.$t('暂无阶梯') })
    }
  }
}
</script>

<style scoped>
.table-operations { margin-bottom: 16px; }
.danger-link { color: #f5222d; }
</style>
